import React from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

const panelSx = {
  maxWidth: 765,
  mx: "auto",
  border: "1px solid #e0e0e0",
  borderRadius: 2,
  padding: 3,
  mt: 3,
  mb: 3,
  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
  backgroundColor: "#f3f4f6",
};

/**
 * Billing Method + Additional Information panels (internal users only).
 */
export function BondRetrievalInternalPanels({
  role,
  billingMethod,
  setBillingMethod,
  isIndemnityReceived,
  setIsIndemnityReceived,
  editableCreatedAt,
  setEditableCreatedAt,
  data,
}) {
  if (role !== "super_user" && role !== "internal_user") {
    return null;
  }

  return (
    <>
      <Box sx={panelSx}>
        <Typography variant="h5" className="font-bold mb-4">
          Billing Method
        </Typography>
        <RadioGroup
          row
          value={billingMethod}
          onChange={(e) => setBillingMethod(e.target.value)}
        >
          <FormControlLabel
            value="Direct Bill"
            control={<Radio />}
            label="Direct Bill"
            sx={{ mr: 4 }}
          />
          <FormControlLabel
            value="Agency Bill"
            control={<Radio />}
            label="Agency Bill"
          />
        </RadioGroup>
      </Box>

      <Box sx={panelSx}>
        <Typography variant="h5" className="font-bold mb-4">
          Additional Information
        </Typography>
        <TextField
          select
          label="Is Signed Indemnity Received"
          value={isIndemnityReceived}
          onChange={(e) => setIsIndemnityReceived(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        >
          <MenuItem value="">Not Selected</MenuItem>
          <MenuItem value="Yes">Yes</MenuItem>
          <MenuItem value="No">No</MenuItem>
        </TextField>
        <TextField
          fullWidth
          label="Created At"
          type="datetime-local"
          value={editableCreatedAt}
          onChange={(e) => setEditableCreatedAt(e.target.value)}
          sx={{ mb: 2 }}
          slotProps={{ inputLabel: { shrink: true } }}
          helperText={
            data?.created_at
              ? `Current: ${new Date(data.created_at).toLocaleString()}`
              : ""
          }
        />
      </Box>
    </>
  );
}

export default BondRetrievalInternalPanels;
